import type { DevToolFlag } from './types';
import { ToggleSwitch } from './ToggleSwitch';

export function FlagRow({ flag }: { flag: DevToolFlag }) {
  return (
    <div className="caddietw-flex caddietw-items-center caddietw-justify-between caddietw-py-2.5 caddietw-px-3 caddietw-rounded caddietw-transition-colors hover:caddietw-bg-gray-50">
      <div className="caddietw-flex caddietw-items-center caddietw-gap-2 caddietw-min-w-0">
        <div className="caddietw-min-w-0">
          <div className="caddietw-text-sm caddietw-font-medium caddietw-text-gray-900">
            {flag.label}
          </div>
          <div className="caddietw-text-xs caddietw-text-gray-400 caddietw-font-mono">
            {flag.key}
          </div>
        </div>
        {flag.isOverridden && (
          <button
            type="button"
            onClick={flag.toggle}
            className="caddietw-text-[10px] caddietw-px-1.5 caddietw-py-0.5 caddietw-rounded caddietw-bg-amber-50 caddietw-text-amber-600 caddietw-border caddietw-border-amber-200 caddietw-cursor-pointer hover:caddietw-bg-amber-100 caddietw-transition-colors caddietw-whitespace-nowrap caddietw-flex-shrink-0"
            title={`Reset to default (${flag.defaultValue})`}
          >
            modified
          </button>
        )}
      </div>
      <ToggleSwitch checked={flag.currentValue} onChange={flag.toggle} />
    </div>
  );
}
